module.exports = __webpack_public_path__ + "img/810.97d69d81.jpg";